module.exports = __webpack_public_path__ + "static/media/long-arrow-right.2ecc732c.svg";